// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-module--container--3Dvn1","social":"Footer-module--social--3TlR5","links":"Footer-module--links--1Q58F"};